import {Tag} from 'antd';

import {useLocale} from '../../../../../../provider/locale/locale-hook';

import {getPositionTagColor} from './answers-feed-helper';

type PropsType = {
    position: number;
};

// Where the brand ranked inside the answer; the top positions get a distinct color.
export function AnswerPositionTag(props: PropsType): JSX.Element {
    const {position} = props;
    const {getLocalizedString} = useLocale();

    return (
        <Tag color={getPositionTagColor(position)}>
            {`${getLocalizedString('AI_BRAND_MONITORING__ANSWERS__POSITION')}: ${position}`}
        </Tag>
    );
}
